module.exports = __webpack_public_path__ + "img/Zostera_marina.19067d8d.jpg";